import React, { useState } from "react";
import { SFTypography, SFStack, SFUseStyled, SFIconButton } from "@sf-core";
import CourseDetailsButton from "../../../core/components/icons/courseDetailsButton";
import JobDetailsDialog from "./jobDetailsDialog";

const { styled } = SFUseStyled();

const SFStyledStack = styled(SFStack, {
  shouldForwardProp: (prop) => prop !== "showButton",
})(({ theme, showButton }) => ({
  borderRadius: theme.spacing(1),
  background: "rgba(255, 255, 255, 0.01)",
  height: "110px",
  width: "100%",
  ...(showButton && {
    background: "rgba(255, 255, 255, 0.03)",
  }),
  marginBottom: theme.spacing(2),
  position: "relative",
}));

const ThumbnailStack = styled("div", {
  shouldForwardProp: (prop) => prop !== "backgroundImage",
})(({ theme, backgroundImage }) => ({
  minWidth: "80px",
  maxWidth: "80px",
  height: "100%",
  borderRadius: theme.spacing(1, 0, 0, 1),
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
}));

const StyledButtonStack = styled(SFStack)(({ theme }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  width: "55px",
  borderRadius: theme.spacing(0, 1, 1, 0),
  background: "rgba(50,50,60, 0.95)",
  height: "100%",
}));

const SFTypographyStack = styled(SFStack)(({ theme }) => ({
  height: "100%",
  width: "80%",
  padding: theme.spacing(0, 2),
}));

export const MenuVerticalTabs = ({
  item,
  isSkillpathTab = false,
  customThumbnail = null,
}) => {
  const [showButton, setShowButton] = useState(false);
  const [dialog, setDialog] = useState({ open: false });

  return (
    <React.Fragment>
      {dialog.open && (
        <JobDetailsDialog dialog={dialog} setDialog={setDialog} />
      )}
      <SFStyledStack
        direction="row"
        onMouseOver={() => setShowButton(true)}
        onMouseLeave={() => setShowButton(false)}
        showButton={showButton}
      >
        <ThumbnailStack
          backgroundImage={customThumbnail ? customThumbnail : item.thumbnail}
        />
        <>
          <SFTypographyStack
            direction="column"
            alignItems="flex-start"
            justifyContent="center"
            spacing={1}
          >
            <SFTypography variant="body2bold">
              {isSkillpathTab ? item.name : item.domainName}
            </SFTypography>
            <SFTypography variant="body1" maxLines={2}>
              {item.description}
            </SFTypography>
          </SFTypographyStack>
        </>

        {!isSkillpathTab && showButton && (
          <StyledButtonStack alignItems="center" justifyContent="center">
            <SFIconButton
              onClick={(event) => {
                event.stopPropagation();
                setDialog({
                  open: true,
                  jobId: item.jobRoleId,
                  domainId: item.domainId,
                });
              }}
              variant="transparent"
            >
              <CourseDetailsButton />
            </SFIconButton>
          </StyledButtonStack>
        )}
      </SFStyledStack>
    </React.Fragment>
  );
};

export default MenuVerticalTabs;
